<template lang="pug">
b-input-group(size="sm")
  date-picker(
    v-model="dateRange"
    :range="range"
    :type="type"
    lang="en"
    :format="format"
    :minute-step="minuteStep"
    append-to-body=false
    :shortcuts="shortcuts"
    :placeholder="placeholder"
    @input="handleInput"
    v-bind:clearable="false"
    v-bind:editable="false"
    :not-before="notBeforeDate"
    :not-after="notAfterDate"
    height=24
  )
</template>

<script>
const today = new Date();
today.setHours(0, 0, 0, 0);

export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    format: {
      type: String,
      default: "YYYY-MM-DD"
    },
    placeholder: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "date"
    },
    range: {
      type: Boolean,
      default: true
    },
    minuteStep: {
      type: Number,
      default: 1
    },
    value: {
      type: Array,
      default: null
    },
    notBefore: {
      type: String,
      default: ""
    },
    notAfter: {
      type: String,
      default: ""
    },
    isDailyMetrics: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dateRange: this.value
    };
  },
  computed: {
    notBeforeDate() {
      if (this.notBefore === "")
        return this.$moment(
          this.$moment()
            .startOf("month")
            .subtract(4, "month")
            .toDate()
        ).format("YYYY-MM-DD");
      return this.notBefore;
    },
    notAfterDate() {
      if (this.notAfter === "") return this.$moment().format("YYYY-MM-DD");
      return this.notAfter;
    },
    shortcuts() {
      if(this.isDailyMetrics) {
        return [
          {
            text: this.$t("ui.today"),
            onClick: () => {
              this.shortcutsClick("today");
            }
          },
          {
            text: this.$t("ui.yesterday"),
            onClick: () => {
              this.shortcutsClick("yesterday");
            }
          },
          {
            text: this.$t("ui.thisweek"),
            onClick: () => {
              this.shortcutsClick("thisweek");
            }
          },
          {
            text: this.$t("ui.lastweek"),
            onClick: () => {
              this.shortcutsClick("lastweek");
            }
          },
          {
            text: this.$t("ui.thismonth"),
            onClick: () => {
              this.shortcutsClick("thismonth");
            }
          },
          {
            text: this.$t("ui.lastmonth"),
            onClick: () => {
              this.shortcutsClick("lastmonth");
            }
          }
        ];
      }

      return [
          {
            text: this.$t("ui.today"),
            onClick: () => {
              this.shortcutsClick("today");
            }
          },
          {
            text: this.$t("ui.yesterday"),
            onClick: () => {
              this.shortcutsClick("yesterday");
            }
          },
          {
            text: this.$t("ui.thisweek"),
            onClick: () => {
              this.shortcutsClick("thisweek");
            }
          },
          {
            text: this.$t("ui.lastweek"),
            onClick: () => {
              this.shortcutsClick("lastweek");
            }
          },
          {
            text: this.$t("ui.thismonth"),
            onClick: () => {
              this.shortcutsClick("thismonth");
            }
          },
          {
            text: this.$t("ui.lastmonth"),
            onClick: () => {
              this.shortcutsClick("lastmonth");
            }
          },
          {
            text: this.$t("ui.last3month"),
            onClick: () => {
              this.shortcutsClick("last3month");
            }
          }
        ];
    }
  },
  watch: {
    dateRange: function(newVal, oldVal) {
      if(!this.isDailyMetrics) return;
      var newValStartDate = this.$moment(new Date(newVal[0]))
      var newValEndDate = this.$moment(new Date(newVal[1]))
      var oldValStartDate = this.$moment(new Date(oldVal[0]))
      var oldValEndDate = this.$moment(new Date(oldVal[1]))
      var getDeductOneMonthDate = newValEndDate.subtract(31, 'days')

      if(getDeductOneMonthDate > newValStartDate) {
        if(!newValStartDate.isSame(oldValStartDate)) {
          newValEndDate = newValStartDate.add(30, 'days');
          this.dateRange = [newVal[0], newValEndDate]
        }
        else if(!newValEndDate.isSame(oldValEndDate)) {
          newValStartDate = getDeductOneMonthDate;
          this.dateRange = [newValStartDate, newVal[1]]
        }

        this.$store.dispatch("layout/setDateRange", this.dateRange);
        this.$emit("input", this.dateRange);
      }
    }
  },
  methods: {
    handleInput: function(currentValue) {
      this.$store.dispatch("layout/setDateRange", this.dateRange);
      this.$emit("input", currentValue);
    },
    shortcutsClick: function(clickedShortcut) {
      switch (clickedShortcut) {
        case "today":
          this.dateRange = [
            this.$moment()
              .startOf("day")
              .toDate(),
            this.$moment()
              .endOf("day")
              .toDate()
          ];
          break;
        case "yesterday":
          this.dateRange = [
            this.$moment()
              .startOf("day")
              .subtract(1, "days")
              .toDate(),
            this.$moment()
              .endOf("day")
              .subtract(1, "days")
              .toDate()
          ];
          break;
        case "thisweek":
          this.dateRange = [
            this.$moment()
              .startOf("isoweek")
              .toDate(),
            this.$moment()
              .endOf("isoweek")
              .toDate()
          ];
          break;
        case "lastweek":
          this.dateRange = [
            this.$moment()
              .startOf("isoweek")
              .subtract(1, "weeks")
              .toDate(),
            this.$moment()
              .endOf("isoweek")
              .subtract(1, "weeks")
              .toDate()
          ];
          break;
        case "thismonth":
          this.dateRange = [
            this.$moment()
              .startOf("month")
              .toDate(),
            this.$moment()
              .endOf("month")
              .toDate()
          ];
          break;
        case "lastmonth":
          this.dateRange = [
            this.$moment()
              .startOf("month")
              .subtract(1, "month")
              .toDate(),
            this.$moment()
              .endOf("month")
              .subtract(1, "month")
              .toDate()
          ];
          break;
        case "last3month":
          this.dateRange = [
            this.$moment()
              .startOf("month")
              .subtract(3, "month")
              .toDate(),
            this.$moment()
              .endOf("month")
              .subtract(1, "month")
              .toDate()
          ];
          break;
        default:
          break;
      }

      if(this.isDailyMetrics) {
        var startDate = this.dateRange[0];
        var endDate = this.dateRange[1];

        if(this.isDailyMetrics) {
          if(startDate < this.$moment(new Date('2024-03-11')).toDate())
            startDate = this.$moment(new Date('2024-03-11')).toDate()

          if(endDate < this.$moment(new Date('2024-03-11')).toDate())
            endDate = this.$moment(new Date('2024-03-11')).toDate()
        }

        this.dateRange = [startDate, endDate];
      }

      this.$store.dispatch("layout/setDateRange", this.dateRange);
      this.$emit("input", this.dateRange);
    }
  }
};
</script>

<style lang="scss" scoped>
.input-group-text {
  width: 160px;
}

.mx-input {
  height: 26px !important;
}
</style>
